import { SvgIconProps } from './icon-props';

export default function LocationPinLargeFill({
	height = 32,
	strokeWidth = 0.7,
	width,
}: SvgIconProps) {
	return (
		<svg height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
			<path
				d="M26 12.46c0 1.87-1 4.52-2.88 7.78a81.24 81.24 0 0 1-2 3.31 93.001 93.001 0 0 1-3.33 4.81c-.4.54-.76 1-1.1 1.46l-.41.54a.48.48 0 0 1-.76 0l-.41-.54c-.34-.43-.71-.92-1.1-1.46a93.001 93.001 0 0 1-3.33-4.81c-.74-1.14-1.42-2.25-2-3.31-1.86-3.24-2.89-5.91-2.89-7.78a10.12 10.12 0 1 1 20.24 0z"
				stroke="#fff"
				stroke-width={strokeWidth}
				fillRule="evenodd"
			/>
		</svg>
	);
}
